<template>
  <div>
    <h1>Settings</h1>
    <div class="card inner">
      <a-empty> </a-empty>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.inner {
  display: flex;
  min-height: 600px;
  align-items: center;
  justify-content: center;
}
</style>
